'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRanges = exports.defineds = exports.dateFormat = exports.locale = undefined;

var _dateFns = require('date-fns');

var _pl = require('date-fns/locale/pl');

var _pl2 = _interopRequireDefault(_pl);

var _reactDateRange = require('react-date-range');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var locale = exports.locale = _pl2.default;
var dateFormat = exports.dateFormat = 'DD.MM.YYYY';
var defineds = exports.defineds = {
  startOfWeek: (0, _dateFns.addDays)((0, _dateFns.startOfWeek)(new Date()), 1),
  endOfWeek: (0, _dateFns.addDays)((0, _dateFns.endOfWeek)(new Date()), 1),
  startOfLastWeek: (0, _dateFns.addDays)((0, _dateFns.startOfWeek)((0, _dateFns.addWeeks)(new Date(), -1)), 1),
  endOfLastWeek: (0, _dateFns.addDays)((0, _dateFns.endOfWeek)((0, _dateFns.addWeeks)(new Date(), -1)), 1),
  startOfToday: (0, _dateFns.startOfDay)(new Date()),
  endOfToday: (0, _dateFns.endOfDay)(new Date()),
  startOfYesterday: (0, _dateFns.startOfDay)((0, _dateFns.addDays)(new Date(), -1)),
  endOfYesterday: (0, _dateFns.endOfDay)((0, _dateFns.addDays)(new Date(), -1)),
  startOfMonth: (0, _dateFns.startOfMonth)(new Date()),
  endOfMonth: (0, _dateFns.endOfMonth)(new Date()),
  startOfLastMonth: (0, _dateFns.startOfMonth)((0, _dateFns.addMonths)(new Date(), -1)),
  endOfLastMonth: (0, _dateFns.endOfMonth)((0, _dateFns.addMonths)(new Date(), -1)),
  startOfYear: (0, _dateFns.startOfYear)(new Date()),
  endOfYear: (0, _dateFns.endOfYear)(new Date()),
  startOfLastYear: (0, _dateFns.startOfYear)((0, _dateFns.addYears)(new Date(), -1)),
  endOfLastYear: (0, _dateFns.endOfYear)((0, _dateFns.addYears)(new Date(), -1)),
  sevenDaysAgo: (0, _dateFns.subDays)(new Date(), 6)
};
var staticRanges = exports.staticRanges = (0, _reactDateRange.createStaticRanges)([{
  label: 'Dzisiaj',
  range: function range() {
    return {
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday
    };
  }
}, {
  label: 'Wczoraj',
  range: function range() {
    return {
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday
    };
  }
}, {
  label: 'Ten tydzień',
  range: function range() {
    return {
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek
    };
  }
}, {
  label: 'Zeszły tydzień',
  range: function range() {
    return {
      startDate: defineds.startOfLastWeek,
      endDate: defineds.endOfLastWeek
    };
  }
}, {
  label: 'Ten miesiąc',
  range: function range() {
    return {
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth
    };
  }
}, {
  label: 'Zeszły miesiąc',
  range: function range() {
    return {
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth
    };
  }
}, {
  label: 'Ten rok',
  range: function range() {
    return {
      startDate: defineds.startOfYear,
      endDate: defineds.endOfYear
    };
  }
}, {
  label: 'Zeszły rok',
  range: function range() {
    return {
      startDate: defineds.startOfLastYear,
      endDate: defineds.endOfLastYear
    };
  }
}]);